import { render, staticRenderFns } from "./dealer-select.vue?vue&type=template&id=324d2808"
import script from "./dealer-select.vue?vue&type=script&lang=js"
export * from "./dealer-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports